// Grid and List keep the values `GridListViewModeEnum` stores, so a saved choice still parses.
export enum BlogListViewModeEnum {
  Grid = 'grid',
  List = 'list',
  Tree = 'tree',
}
